import React, { useState } from "react";
import { ReactComponent as RaceSportIcon } from '../assets/images/race-flag.svg';

import { getUrlToFetch } from '../data/utils/getUrlToFetch';
import { getAccountIds } from '../data/utils/getAccountIds';
import { getConfiguration } from '../data/utils/configuration';
import { useFetch } from "../data/fetch/useFetch";
import { concatUrlPathnames } from "../data/sport-utils";
import { systemCode } from "..";
import { labels } from "../data/labels";

export default function RaceSportButton(props) {

    const conf = getConfiguration();
    const [isRaceActive,setIsRaceActive] = useState(false);
    const numConto = getAccountIds()?.split(";")?.[1] || '';
    let hrefLink = '/xcasinoracesport';

    try {
        if(typeof window.cg_SEO_URL_MAPPING_REVERSE != 'undefined') {
            hrefLink = concatUrlPathnames('/',JSON.parse(window.cg_SEO_URL_MAPPING_REVERSE)['xcasinoracesport']);
        }
    }catch(err) {
        console.error(err);
    }

    const [isLoading, isError, data] = useFetch(getUrlToFetch(conf.xrc?.url), {system_code:systemCode, num_conto:numConto, skipBaseParams:true}, (data) =>{
        try {
            if(parseInt(data?.raceAttiva) > 0 && !isRaceActive){
                setIsRaceActive(true);
            }
        }catch(err) {
            if(isRaceActive) {
                setIsRaceActive(false);
            }
            console.error(err);
        }
    },
    conf.xrc?.enabled
    );

    return (isRaceActive &&
        <>
            <a href={hrefLink} className={"xsport-race-sport-icon-container nav-slider-item-container sport-img-slider"} >
                <div className="sport-img-container">
                    <div className={`sport-img xsport-race-sport`}><RaceSportIcon /></div>
                    
                </div>
                <div className="nav-slider-item">{labels['race_sport.title']? labels['race_sport.title'] : 'Race Sport'}</div>
            </a>
        </>
    )
}